import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import Colors from '../../../layout/theme/utils/colors';

export const StyledPOStatusButton = styled(Button)(({ theme }) => ({
  margin: 0,
  cursor: 'default',
  '&:hover': {
    backgroundColor: Colors.white + ' !important',
  },
  padding: theme.spacing(1.25, 1.875, 1.25, 1.5),
  fontWeight: 600,
  fontSize: '12px',
  lineHeight: '15px',
  backgroundColor: Colors.white,
  color: Colors.almost_black,
  borderRadius: 4,
}));
